import React, { Component } from 'react'

import ReactMarkdown from "react-markdown"


import {Link} from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import Video from "./WistiaEmbed.js"
import VideoIcon from "../images/video-01.svg"
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';



class ProjectGrid extends Component {
  constructor(props) {
    super(props)

    this.state = {
    Modal:false
  };

  this.targetRef = React.createRef();
  this.targetElement = null;


    this.returnImage = this.returnImage.bind(this)

    this.layoutContents = React.createRef()

  }


  ModalShow = (event) => {

  if(this.state.Modal){
  this.setState({ Modal: false });
      enableBodyScroll(this.targetElement);

}else{
    this.setState({ Modal: true });
  disableBodyScroll(this.targetElement);
}
};


  returnImage(image){

    return ([
image,
`linear-gradient(${this.props.data.TileBackgroundColor}, ${this.props.data.TileBordercolor})`
].reverse()
)

  }

  render() {





    return (
<>
      <li className="slice__item list__item row__item row__item--span-1">

          <div className="item itemEnlarge item--has-image item_title_bottom">
    <BackgroundImage Tag="div" className="item__container" fluid={this.returnImage(this.props.data.image)}>

                  <div className="item__media">
<img className="vidIcon" src={VideoIcon}/>
                  </div>
                  <div className="item__content">
                      <div className="item__header">
                          <h3 className="item__title" style={{color:this.props.data.TileTextColor}}>
                              <a className="item__link" href="#">
                                  {this.props.data.title}
                              </a>
                          </h3>
                      </div>
                      <div className="item__teaser">

                      </div>
                  </div>
                  <div className="block-link-overlay" onClick={this.ModalShow}></div>

                            </BackgroundImage>
              </div>

      </li>
      {this.state.Modal ?
          <>
          <div className="ModalBack" onClick={this.ModalShow} ref={this.targetRef}></div>
          <div className="videoinner">
          <Video hashedId={this.props.data.author} playerColor={this.props.data.sub_message} />
          </div>
          </>:<></>
        }
      </>


    )


}
}

export default ProjectGrid;
